import React from "react";
import { Popup } from "react-mapbox-gl";
import styled from "styled-components";

import { KMLEntry } from "../../../interfaces";
import { basic } from "../../../theme/colors";
import { MarkerDescription } from "./MarkerDescription";

const StyledPopup = styled.div`
  background: white;
  color: ${basic.haydenDarkBrand};
  font-weight: 400;
  padding: 5px;
  border-radius: 2px;
`;

interface Props {
    lat: number;
    lon: number;
    selectedMarker: KMLEntry | null;
}

export const MapPopup = (props: Props) => {
    const { selectedMarker, lat, lon } = props;

    if (!selectedMarker) {
        return null;
    }

    return (
        <Popup coordinates={[lon, lat]}>
            <StyledPopup>
                <MarkerDescription marker={selectedMarker} />
            </StyledPopup>
        </Popup>
    )
}
